<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-5 w-5 color-c4c4c4"
    viewBox="0 0 20 20"
    :fill="fillStr && fillStr.length ? `${fillStr}` : `currentColor`"
    :class="classStr"
  >
    <path
      fill-rule="evenodd" stroke-width="1" stroke="#8dc73f"
      d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: "Heart",
  props: {
    data: {
      type: Array,
    },
    classStr: {
      type: String,
    },
    fillStr: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
.color-c4c4c4  {
  color: #c4c4c4;
}

</style>